import { eventsConstants, authConstants } from '../constants';
import { MessagesActions } from './';
import { EventsApi } from '../services';

export class EventsActions {
    static setCurrentEventID(eventID) {
        return (dispatch) => {
            dispatch({type: eventsConstants.SET_CURRENT_EVENT_ID, payload: eventID});
        }
    }

    static unSetCurrentEventID() {
        return (dispatch) => {
            dispatch({type: eventsConstants.UNSET_CURRENT_EVENT_ID});
        }
    }

    static getAllEventsData () {
        return (dispatch) => {
            dispatch({type: eventsConstants.GET_ALL_EVENTS_DATA_REQUEST});

            EventsApi.getAllEventsData()
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: eventsConstants.GET_ALL_EVENTS_DATA_SUCCESS, payload: res.data});
                        return;
                    }

                    return dispatch({type: eventsConstants.GET_ALL_EVENTS_DATA_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: eventsConstants.GET_ALL_EVENTS_DATA_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה בטעינת האירוע'));
                });
        }
    }

    static getEventData (eventID) {
        return (dispatch) => {
            dispatch({type: eventsConstants.GET_EVENT_DATA_REQUEST});

            EventsApi.getEventData(eventID)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: eventsConstants.GET_EVENT_DATA_SUCCESS, payload: {[eventID]: res.data}});
                        return;
                    }

                    return dispatch({type: eventsConstants.GET_EVENT_DATA_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: eventsConstants.GET_EVENT_DATA_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה בטעינת האירוע'));
                });
        }
    }

    static updateEvent (eventID, data) {
        return (dispatch) => {
            dispatch({type: eventsConstants.UPDATE_EVENT_DATA_REQUEST});

            EventsApi.updateEvent(eventID, data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: eventsConstants.UPDATE_EVENT_DATA_SUCCESS, payload: {[eventID]: res.data}});
                        // dispatch(MessagesActions.pushSuccess(`האירוע ${res.data.name} עודכן בהצלחה!`));
                        return;
                    }

                    dispatch(MessagesActions.pushError('לא ניתן לעדכן את האירוע (שימו לב: לא ניתן לעדכן תאריך תחילת אירוע לאחר שהוא כבר התחיל אם זו לא הסיבה נסו לרענן את העמוד)'));
                    return dispatch({type: eventsConstants.UPDATE_EVENT_DATA_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: eventsConstants.UPDATE_EVENT_DATA_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/events.js